// ==============================|| OVERRIDES - DRAWER ||============================== //

export default function Drawer(theme) {
  return {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          backgroundColor: theme.vars.palette.background.paper,
          '& .MuiTypography-root': {
            color: theme.vars.palette.text.primary,
          },
          '& .MuiTypography-subtitle2': {
            color: theme.vars.palette.text.secondary,
            fontWeight: 700,
          },
          '& .MuiListItemIcon-root': {
            color: theme.vars.palette.text.secondary,
          },
          '& .MuiListItemButton-root': {
            color: theme.vars.palette.text.secondary,
            '&:hover': {
              backgroundColor: theme.vars.palette.action.hover,
              color: theme.vars.palette.text.primary,
              '& .MuiListItemIcon-root': {
                color: theme.vars.palette.text.primary
              },
              '& .MuiTypography-root': {
                color: theme.vars.palette.text.primary
              }
            },
            '&.Mui-selected': {
              backgroundColor: `${theme.vars.palette.action.selected} !important`,
              color: theme.vars.palette.primary.main,
              borderRight: `3px solid ${theme.vars.palette.primary.main}`,
              '& .MuiListItemIcon-root': {
                color: theme.vars.palette.primary.main
              },
              '& .MuiTypography-root': {
                color: theme.vars.palette.primary.main,
                fontWeight: 600
              },
              '&:hover': {
                backgroundColor: `${theme.vars.palette.action.selected} !important`
              }
            }
          },
          // Expand/collapse chevron SVGs
          '& svg': {
            color: theme.vars.palette.text.secondary
          }
        }
      }
    }
  };
}
